import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { User } from '@core/modules/user/models';
import { MyDevicesFormState } from '../../types/my-devices-form-builder-service.type';
import { MyDeviceFormService } from '../../services/my-device-form.service';
import { DeviceUserFormControlName } from '../../models';
import { DeviceBlockService } from '../../services/device-block.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
    selector: 'app-new-device',
    templateUrl: './new-device.component.html',
    styleUrls: ['./new-device.component.scss'],
    standalone: false
})
export class NewDeviceComponent implements OnInit {
  @Input() idx!: number;
  @Input() user!: User;
  @Input() form!: FormGroup;
  @Input() deviceControl!: AbstractControl;
  @Input() myDevicesFormState!: MyDevicesFormState;
  @Input() hasProfile!: boolean;

  @Output() changedPassphraseValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeAddAnotherDevice: EventEmitter<number> = new EventEmitter<number>();

  errorFeedbackList = this.deviceBlockService.loadFeedbackErrorLists();

  // serial form control
  get serialControl(): FormControl {
    return this.deviceControl.get(DeviceUserFormControlName.SERIAL) as FormControl;
  }

  get isValidSerial() {
    return this.serialControl.valid;
  }

  get isSubmittedSerialControl() {
    return this.deviceBlockService.isSubmittedSerialControl(this.serialControl);
  }
  // ===

  // passphrase form control
  get passphraseControl(): FormControl {
    return this.deviceControl.get(DeviceUserFormControlName.PASSPHRASE) as FormControl;
  }

  get isSubmittedPassphraseControl() {
    return this.deviceBlockService.isSubmittedPassphraseControl(this.passphraseControl);
  }
  // ===

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly deviceBlockService: DeviceBlockService,
    private readonly myDeviceFormService: MyDeviceFormService
  ) {}

  ngOnInit(): void {
    this.errorFeedbackList = this.deviceBlockService.loadFeedbackErrorLists();

    this.form.statusChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => {
          this.deviceBlockService.resetSubmittedWhenPassphraseError(
            this.myDevicesFormState,
            this.passphraseControl
          );
        })
      )
      .subscribe();
  }

  onRemoveInput(index: number): void {
    this.removeAddAnotherDevice.emit(index);
  }

  onChangedSerial(value: string): void {
    this.deviceBlockService.onChangedSerial(
      this.form,
      this.myDevicesFormState,
      this.serialControl,
      value
    );
  }

  onUseSharedDevice(useSharedDevice: boolean): void {
    this.deviceBlockService.onUseSharedDevice(
      this.form,
      this.myDevicesFormState,
      <FormGroup>this.deviceControl,
      useSharedDevice
    );
  }

  onChangedPassphrase(value: string): void {
    this.changedPassphraseValue.emit(value);
  }

  onOpenSharedDeviceInfo(): void {
    this.myDeviceFormService.openSharedDeviceInfo();
  }

  onOpenSerialInfo(): void {
    this.myDeviceFormService.openSerialInfo();
  }

  isShowProblemFormFor(): boolean {
    return this.deviceBlockService.isShowProblemFormFor(this.serialControl);
  }
}
